/*-----------------------------------------------------------------------------------*/
/*  FETCH DATA FUNCTION - Generic function to fetch API data npx gulp 
/*-----------------------------------------------------------------------------------*/
async function fetchData(url) {
	try {
			const response = await fetch(url);
			if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
			return await response.json();
	} catch (error) {
			console.error(`Error fetching data from ${url}:`, error);
			return null;
	}
}

/*-----------------------------------------------------------------------------------*/
/*  UPDATE DOM FUNCTION - Injects fetched HTML content into a target element
/*-----------------------------------------------------------------------------------*/
function updateDOM(id, htmlContent) {
	const element = document.getElementById(id);
	if (element) {
			//console.log(`Updating DOM for element: ${id}`);
			element.innerHTML = htmlContent;
	} else {
			console.error(`Element with id "${id}" not found.`);
	}
}

/*-----------------------------------------------------------------------------------*/
/*  LOAD TRENDING GAMES - Fetches and displays trending games for a given category
/*-----------------------------------------------------------------------------------*/
async function loadTrendingGames(id, subgroup) {
	//console.log(`Loading trending games for: ${subgroup}`);
	try {
			const response = await fetch(`/sections/SiteController.php?games=trendinggame&subgroup=${encodeURIComponent(subgroup)}`);

			if (!response.ok) throw new Error(`Error fetching trending games. Status: ${response.status}`);

			const responseText = await response.text();
			updateDOM(id, responseText);
	} catch (error) {
			console.error(`Error in loadTrendingGames: ${error.message}`);
	}
}

/*-----------------------------------------------------------------------------------*/
/*  LOAD JACKPOT GAMES - Fetches and displays jackpot games
/*-----------------------------------------------------------------------------------*/
async function loadJackpotGames(id) {
	//console.log("Loading jackpot games...");
	try {
			const response = await fetch("/sections/SiteController.php?games=jackpotgames");

			if (!response.ok) throw new Error(`Error fetching jackpot games. Status: ${response.status}`);

			const responseText = await response.text();
			updateDOM(id, responseText);
	} catch (error) {
			console.error(`Error in loadJackpotGames: ${error.message}`);
	}
}

/*-----------------------------------------------------------------------------------*/
/*  LOAD NEW GAMES - Fetches and displays new games
/*-----------------------------------------------------------------------------------*/
async function loadNewGames(id) {
	//console.log("Loading new games...");
	try {
			const response = await fetch("/sections/SiteController.php?games=newgames");

			if (!response.ok) throw new Error(`Error fetching new games. Status: ${response.status}`);

			const responseText = await response.text();
			updateDOM(id, responseText);
	} catch (error) {
			console.error(`Error in loadNewGames: ${error.message}`);
	}
}

/*-----------------------------------------------------------------------------------*/
/*  LOAD TOURNAMENTS - Fetches and displays tournament data
/*-----------------------------------------------------------------------------------*/
async function loadgettournamnets(id) {
	//console.log("Loading tournaments...");
	try {
			const response = await fetch("/app/shared/controllers/TournamentsController.php?upcoming");

			if (!response.ok) throw new Error(`Error fetching tournaments. Status: ${response.status}`);

			const tournamentsList = await response.json();
			if (tournamentsList.length === 0) {
					document.getElementById(id).style.display = "none";
					return;
			}

			let html = "";
			for (let i = 0; i < Math.min(3, tournamentsList.length); i++) {
					const tournament = tournamentsList[i];
					const gameResponse = await fetch(`/sections/SiteController.php?games=singlegames&gameid=${tournament.game_id}&machineid=${tournament.mach_id}`);
					const image = await gameResponse.json();

					if (image.simple_name) {
							const tournamentHtml = generateTournamentHTML(tournament, image);
							html += tournamentHtml;
					}
			}

			updateDOM(id, `<div class="tournaments-container container"><div class="swiper tournaments"><div class="swiper-wrapper">${html}</div></div></div>`);

			new Swiper(".tournaments", { loop: true, navigation: { nextEl: ".swiper-button-next3", prevEl: ".swiper-button-prev3" } });

	} catch (error) {
			console.error(`Error in loadgettournamnets: ${error.message}`);
	}
}

/*-----------------------------------------------------------------------------------*/
/*  LOAD WINNERS DATA - Fetches and displays winners data
/*-----------------------------------------------------------------------------------*/
async function loadWinnersData(id) {
	try {
			const response = await fetch("/sections/SiteController.php?section=getwinners");

			if (!response.ok) throw new Error("Error fetching winners data.");

			const responseText = await response.text();
			updateDOM(id, responseText);
	} catch (error) {
			console.error(`Error in loadWinnersData: ${error.message}`);
	}
}

/*-----------------------------------------------------------------------------------*/
/*  GENERATE TOURNAMENT HTML - Returns formatted HTML for a tournament entry
/*-----------------------------------------------------------------------------------*/
function generateTournamentHTML(tournament, image) {
	const startDate = new Date(tournament.tournament_start_date).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
	const endDate = new Date(tournament.tournament_end_date).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

	return `
			<div class="swiper-slide">
					<div class="timer-section">
							<h2>Tournaments</h2>
							<div class="timer-inner">
									<h4>${tournament.tournament_name}</h4>
									<p>Start: <span class="timer-red">${startDate}</span> - End: <span class="timer-blue">${endDate}</span></p>
									<p class="price">Prize Pool: <span>R${tournament.prize_pool}</span></p>
							</div>
					</div>
					<div class="tournament-img">
							<img src="${ASSETSDOMAINJS}/rtg/screen/${image.simple_name}.png" alt="${tournament.tournament_name}" />
					</div>
			</div>`;
}
	/*-----------------------------------------------------------------------------------*/
	/*  IMAGE LAZY LOADING - Replace `data-src` with `src` when in view
	/*-----------------------------------------------------------------------------------*/

function loadImgs(){
	//console.log("2 STARTING lazy loading components");


	const lazyImages = document.querySelectorAll('img.lazy');
	const imageObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
					if (entry.isIntersecting) {
						
							const img = entry.target;
							img.src = img.dataset.src;
							img.classList.remove('lazy');
							//console.log('img load '+img);
							observer.unobserve(img);
					}
			});
	});

	lazyImages.forEach(image => imageObserver.observe(image));
}





function checkAndSetAlt(defaultAlt = "image") {
	//console.log("alt image...");
	document.querySelectorAll("img").forEach(img => {
			if (!img.hasAttribute("alt") || img.alt.trim() === "") {
					img.alt = defaultAlt;
			}
	});
}


function loadSliderImages() {
	//console.log("3 loadSliderImages..");
	const slides = document.querySelectorAll(".swiper-slide");

	slides.forEach(slide => {
			const bg = slide.dataset.bg;
			const imgName = slide.dataset.img;

			if (bg) {
					slide.style.backgroundImage = `url('./assets/images/slider/bg-${bg}.jpg')`;
			}

			const img = slide.querySelector(".heroimg");
			if (img && imgName) {
					img.src = `./assets/images/slider/${imgName}.png`;
			}
	});
}

/*-----------------------------------------------------------------------------------*/
/*  INITIALIZE CONTENT LOADING WITH DELAYS
/*-----------------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", async () => {
	//console.log("Starting to load content...");
	// cookies();
	loadImgs();
	function delay(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }

	if (!document.getElementById("hometemplate")) {
			console.error("No 'hometemplate' element found.");
			return;
	}

	try {
			//console.log("1 loadImgs");
			await loadImgs();
			await delay(500);
			
			//console.log("1 loadSliderImages");
			await loadSliderImages();
			await delay(2000);

			await checkAndSetAlt();
			await delay(2500);

			// //console.log("Loading: All Games - Trending");
			// await loadTrendingGames("trendinggames_allGames", "allgames");
			// await delay(2500);

			// //console.log("Loading: Tournaments");
			// await loadgettournamnets("tournamentdatadetail");
			// await delay(2500);

			// //console.log("Loading: Winners Data");
			// await loadWinnersData("getwinners");

	

			//console.log("4 All content loaded successfully!");
	} catch (error) {
			console.error("Error loading data:", error);
	}
});

